/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const brandingDataRequestGenerationErrorSchema = z.enum(['website_unreachable', 'scan_failed'])

export type BrandingDataRequestGenerationErrorSchema = z.infer<typeof brandingDataRequestGenerationErrorSchema>
